import { MessageCircle, Instagram, MapPin, Clock, Globe } from "lucide-react";
import { LOGO_URL, waLink, WHATSAPP_DISPLAY, INSTAGRAM_URL } from "@/data/siteData";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-gold/15 bg-navy-deep">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="RAJ TRAVELS GOA logo" className="w-12 h-12 rounded-full ring-2 ring-gold/60 object-cover" />
            <div className="leading-tight">
              <span className="font-cinzel font-bold tracking-[0.14em] text-ivory block">RAJ TRAVELS</span>
              <span className="font-cinzel text-[10px] tracking-[0.42em] gold-text block">GOA</span>
            </div>
          </div>
          <p className="mt-5 text-[13px] text-slate-400 leading-relaxed max-w-xs">
            Crafting unforgettable Goan holidays — beaches, romance, family fun, adventure and nightlife — with genuine local care.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.24em] text-gold font-semibold mb-5">Contact</p>
          <ul className="space-y-4 text-sm text-slate-300">
            <li>
              <a href={waLink("Hi RAJ TRAVELS GOA!")} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 hover:text-gold transition-colors">
                <MessageCircle className="w-4 h-4 text-gold" /> WhatsApp: {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
                className="flex items-center gap-3 hover:text-gold transition-colors">
                <Instagram className="w-4 h-4 text-gold" /> @raj_travels_goa
              </a>
            </li>
            <li>
              <a href="https://offers.rajtravelsgoa.com" target="_blank" rel="noopener noreferrer" data-testid="footer-website-link"
                className="flex items-center gap-3 hover:text-gold transition-colors">
                <Globe className="w-4 h-4 text-gold" /> offers.rajtravelsgoa.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4 text-gold" /> North Goa, India
            </li>
            <li className="flex items-center gap-3">
              <Clock className="w-4 h-4 text-gold" /> 24x7 support on WhatsApp
            </li>
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.24em] text-gold font-semibold mb-5">Quick Links</p>
          <ul className="space-y-3 text-sm text-slate-300">
            <li><a href="#packages" data-testid="footer-packages-link" className="hover:text-gold transition-colors">Goa Packages</a></li>
            <li><a href="#why-choose" data-testid="footer-why-link" className="hover:text-gold transition-colors">Why RAJ TRAVELS GOA</a></li>
            <li><a href="#experiences" data-testid="footer-experiences-link" className="hover:text-gold transition-colors">Goa Experiences</a></li>
            <li><a href="#enquiry" data-testid="footer-enquiry-link" className="hover:text-gold transition-colors">Plan My Goa Trip</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-6 text-center">
        <p className="text-xs text-slate-500">
          © {new Date().getFullYear()} RAJ TRAVELS GOA. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
